import { Globe2 } from "lucide-react";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { Button } from "@/components/ui/button";
import {
  LANGUAGE_SESSION_OVERRIDE_KEY,
  useI18n,
} from "@/contexts/I18nContext";

export function LanguageMenu() {
  const { language, setLanguage, t } = useI18n();

  const changeLanguage = (nextLanguage) => {
    if (nextLanguage === language) return;
    sessionStorage.setItem(LANGUAGE_SESSION_OVERRIDE_KEY, "true");
    setLanguage(nextLanguage);
    window.location.reload();
  };

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button
          variant="ghost"
          size="icon"
          className="h-10 w-10 rounded-full"
          aria-label={t("profile.language")}
          title={t("profile.language")}
        >
          <Globe2 className="h-6 w-6" />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="min-w-36">
        <DropdownMenuItem onClick={() => changeLanguage("ko")}>
          <span className="w-4">{language === "ko" ? "✓" : ""}</span>
          {t("common.korean")}
        </DropdownMenuItem>
        <DropdownMenuItem onClick={() => changeLanguage("en")}>
          <span className="w-4">{language === "en" ? "✓" : ""}</span>
          {t("common.english")}
        </DropdownMenuItem>
        <DropdownMenuItem onClick={() => changeLanguage("zh-tw")}>
          <span className="w-4">{language === "zh-tw" ? "✓" : ""}</span>
          {t("common.traditionalChinese")}
        </DropdownMenuItem>
        <DropdownMenuItem onClick={() => changeLanguage("zh-cn")}>
          <span className="w-4">{language === "zh-cn" ? "✓" : ""}</span>
          {t("common.simplifiedChinese")}
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
